const defaultSetup = {
  options: {
    productCode: "ingame",
  },
  copyright: "Synergy Sports",
  languages: ["en-AU"],
};

export default defaultSetup
